<div class="step-wrapper">
    <div class="description">
        Select one or more of your existing classes below, or
        <a
            href="/tools/rosters"
            (click)="activeModal.close()"
            target="_blank"
            rel="noopener noreferrer"
            >create a new class.</a
        >
        If you
        <a
            href="/tools/rosters"
            target="_blank"
            rel="noopener noreferrer"
            (click)="activeModal.close()"
            >import a class from Google Classroom</a
        >, you can see student progress in both PBS LearningMedia and Google Classroom.
    </div>
    <div class="classes-wrapper">
        <div class="class-row" *ngFor="let roster of rosters">
            <div class="class-check-box">
                <app-checkbox [type]="'hallow'" [(checked)]="roster.selected"></app-checkbox>
                <div class="class-name">{{ roster.rosterName }}</div>
                <img class="google-class" *ngIf="roster.rosterGoogleId" [src]="googleClassImg" />
            </div>
        </div>

        <div class="class-row">
            <a
                href="/tools/rosters"
                target="_blank"
                rel="noopener noreferrer"
                (click)="activeModal.close()"
                >Create a new class</a
            >
        </div>

        <div class="class-row">
            <a
                href="/tools/rosters"
                target="_blank"
                rel="noopener noreferrer"
                (click)="activeModal.close()"
                >Import class from Google Classroom</a
            >
        </div>
    </div>
    <div class="buttons-wrapepr">
        <app-button (click)="next()" [disable]="!checkIfSelected()" [buttonClasses]="'hallow'"
            >Next: Select Students</app-button
        >
        <app-button (click)="prev()" [buttonClasses]="'hallow'">Go Back</app-button>
    </div>
</div>
